import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewV2Properties } from 'querys/regional-overview/regional-overview.query.models';
import { isAllOrEmpty } from './builders.utils';

export const buildGrowthStagesFilter = <P extends RegionalOverviewV2Properties>(): Filter =>
  buildFilter<P>({
    type: RegionalOverviewFilterType.GROWTH_STAGES,
    defaultValue: [ALL_FILTER_VALUE],
    includeAllOption: true,
    translatable: false,
    getValues: feature => {
      const prevBBCH = feature.properties?.values?.risks?.prevBBCH;
      return prevBBCH ? [prevBBCH] : [];
    },
    matches: (feature, value) => {
      if (isAllOrEmpty(value)) return true;
      const prevBBCH = feature.properties?.values?.risks?.prevBBCH;
      if (!prevBBCH) return false;
      return (value as string[]).includes(prevBBCH);
    }
  });
